import React from 'react';
import { Upload, Mic, Square, Trash2, Check, FileText } from 'lucide-react';

// Admin block: record/upload the coach's own voice for a given target script
export const CoachVoiceAdmin = ({ target, label, coachVoiceMap, isAdmin, uploading, recordingTarget, onPickFile, onStartRecord, onStopRecord, onDelete, onShowScript }) => {
  if (!isAdmin) return null;
  const existing = coachVoiceMap[target];
  const isRec = recordingTarget === target;
  return (
    <div className="p-3 bg-amber-500/5 border border-amber-500/20 rounded-xl" data-testid={`coach-voice-admin-${target}`}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div className="flex items-center gap-2">
          <span className="text-amber-300/80 text-xs">🎙️ Ma voix — {label}</span>
          {existing && (
            <span className="flex items-center gap-1 text-green-400 text-[10px]"><Check className="w-3 h-3" /> Enregistrée</span>
          )}
        </div>
        <div className="flex items-center gap-1.5">
          {onShowScript && (
            <button onClick={() => onShowScript(target, label)}
              className="px-2 py-1.5 rounded-lg bg-sky-500/15 text-sky-300 text-[10px] flex items-center gap-1 hover:bg-sky-500/25"
              data-testid={`coach-script-${target}`}>
              <FileText className="w-3 h-3" /> Script
            </button>
          )}
          <button onClick={() => onPickFile(target, label)} disabled={uploading}
            className="px-2 py-1.5 rounded-lg bg-white/10 text-white/70 text-[10px] flex items-center gap-1 hover:bg-white/15 disabled:opacity-50"
            data-testid={`coach-upload-${target}`}>
            <Upload className="w-3 h-3" /> MP3
          </button>
          {!isRec ? (
            <button onClick={() => onStartRecord(target, label)} disabled={uploading || !!recordingTarget}
              className="px-2 py-1.5 rounded-lg bg-red-500/15 text-red-300 text-[10px] flex items-center gap-1 hover:bg-red-500/25 disabled:opacity-50"
              data-testid={`coach-record-${target}`}>
              <Mic className="w-3 h-3" /> Micro
            </button>
          ) : (
            <button onClick={onStopRecord}
              className="px-2 py-1.5 rounded-lg bg-red-500/40 text-white text-[10px] flex items-center gap-1 animate-pulse"
              data-testid={`coach-stop-record-${target}`}>
              <Square className="w-3 h-3" /> Stop
            </button>
          )}
          {existing && (
            <button onClick={() => onDelete(existing.id)}
              className="p-1.5 rounded-lg bg-red-500/10 text-red-400/70 hover:text-red-400"
              data-testid={`coach-delete-${target}`}>
              <Trash2 className="w-3 h-3" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CoachVoiceAdmin;
